import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';
import { Card } from '@components/common';
import './ReservationCard.scss';

const ReservationCard = ({ reservation, displayType = 'grid', onClick, actions }) => {
    const { t } = useLanguage();

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString();
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleString();
    };

    const getStatusInfo = () => {
        const status = reservation.status;

        switch (status) {
            case 'upcoming':
                return {
                    text: t('reservation.upcoming'),
                    className: 'status-upcoming',
                    variant: 'info'
                };
            case 'active':
                return {
                    text: t('reservation.active'),
                    className: 'status-active',
                    variant: 'primary'
                };
            case 'expired':
            default:
                return {
                    text: t('reservation.expired'),
                    className: 'status-expired',
                    variant: 'secondary'
                };
        }
    };

    const statusInfo = getStatusInfo();

    const handleClick = () => {
        if (onClick) {
            onClick(reservation);
        }
    };

    if (displayType === 'list') {
        return (
            <div className="reservation-card reservation-card--list" onClick={handleClick}>
                <div className="reservation-card__content">
                    <div className="reservation-card__main">
                        <div className="reservation-card__header">
                            <h4 className="reservation-card__resource">
                                {reservation.resource?.name || t('reservation.unknown_resource')}
                            </h4>
                            <span className={`reservation-card__status reservation-card__status--${statusInfo.variant}`}>
                                {statusInfo.text}
                            </span>
                        </div>
                        <div className="reservation-card__details">
                            <span className="reservation-card__user">
                                {t('reservation.user')}: {reservation.user?.name || reservation.user?.email || t('reservation.unknown_user')}
                            </span>
                            <span className="reservation-card__period">
                                {t('reservation.period')}: {formatDateTime(reservation.reserved_from)} - {formatDateTime(reservation.reserved_until)}
                            </span>
                        </div>
                        {reservation.notes && (
                            <div className="reservation-card__notes">
                                <strong>{t('reservation.notes')}:</strong> {reservation.notes}
                            </div>
                        )}
                    </div>
                    {actions && (
                        <div className="reservation-card__actions">
                            {actions}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    // Grid display (default)
    return (
        <Card className="reservation-card reservation-card--grid" onClick={handleClick} hoverable>
            <div className="reservation-card__content">
                <div className="reservation-card__header">
                    <h4 className="reservation-card__resource">
                        {reservation.resource?.name || t('reservation.unknown_resource')}
                    </h4>
                    <span className={`reservation-card__status reservation-card__status--${statusInfo.variant}`}>
                        {statusInfo.text}
                    </span>
                </div>

                <div className="reservation-card__details">
                    <div className="reservation-card__field">
                        <span className="reservation-card__label">{t('reservation.user')}:</span>
                        <span className="reservation-card__value">
                            {reservation.user?.name || reservation.user?.email || t('reservation.unknown_user')}
                        </span>
                    </div>

                    <div className="reservation-card__field">
                        <span className="reservation-card__label">{t('reservation.reserved_from')}:</span>
                        <span className="reservation-card__value">{formatDateTime(reservation.reserved_from)}</span>
                    </div>

                    <div className="reservation-card__field">
                        <span className="reservation-card__label">{t('reservation.reserved_until')}:</span>
                        <span className="reservation-card__value">{formatDateTime(reservation.reserved_until)}</span>
                    </div>
                </div>

                {reservation.notes && (
                    <div className="reservation-card__notes">
                        <span className="reservation-card__label">{t('reservation.notes')}:</span>
                        <p className="reservation-card__value">{reservation.notes}</p>
                    </div>
                )}

                {actions && (
                    <div className="reservation-card__actions">
                        {actions}
                    </div>
                )}
            </div>
        </Card>
    );
};

export default ReservationCard;
